export default {
    namespaced: true,

    state: {
        currency_balance_owing_in_cents: 0,
        transaction_date: '',
        currency_id: '',
    },

    mutations: {
        setData(state, data) {
            state.currency_balance_owing_in_cents = data.currency_balance_in_cents;
            state.transaction_date = data.transaction_date;
            state.currency_id = data.currency_id;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
            state.transaction_date = '';
        },
    },
};
